<template>
    <v-container class="bkgLogin pa-0" fill-height  fluid>
        <v-row class="fill-height bkgOverlay" >
            <v-col cols="12" md="6" class="fill-height d-flex align-center" align="center" >
                <v-form v-if="!esqueciSenha" style="width:100%" class="mx-5 mx-md-10 pa-3 ">
                    <router-link to="/">
                    <v-img class="mb-5" contain width="140px" src="../assets/logo-branco.png" />

                    </router-link>
                    <div class="text-left">
                        <h4 class="white--text">Insira sua senha</h4>
                    </div>
                    <v-text-field solo label="Senha" type="text" name="strNewPassword" v-model="u.newPassword"> </v-text-field>
                    <div class="text-left">
                        <v-btn @click="trocarSenha($event)"  class="text--white mb-5">
                            Confirmar Cadastro
                            <v-icon dark >mdi-arrow-right</v-icon>
                        </v-btn><br/>

                    </div>
                </v-form>
            </v-col>
            <v-col cols="12" md="6"> 
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped>
form { 
    background-color: #170b3b90;    
}
.bkgLogin {
    max-width:100% !important;
}

.bkgOverlay{
  background-color: rgba(0, 0, 0, 0.55);

}
</style>
<script>

export default {
    name: 'Login',
    data(){
        return {
            show1:false,
            u: { 
                newPassword : ""
            },
            esqueciSenha:false
        }
    },
    methods: {
        trocarSenha(e) {
            e.preventDefault()
            let strNewPassword = this.u.newPassword
            if (strNewPassword == "") {
                alert("Por favor digite uma senha.");
                return
            }

            this.$http.post("users/invite/accept",{
                    token:this.$route.query.token,
                    password: strNewPassword
                }).then(response => { 
                    if (response.data != undefined) { 
                        alert("Cadastro confirmado com sucesso.")
                        this.u.strNewPassword = ""
                        this.$router.push("login")
                    }
                })
        }
    }
}
</script>

